/* ML-08 · PARTIAL FAILURE
   Per-establishment results. Partial success stays applied — nothing is rolled
   back — and the override-protection "failure" must not read as an error.
   The everything-wrong world is this frame’s home (ruling 30/08). */
import { Button, ListRow, Note, Pill } from '@/ui'
import { useML } from './EtabShell'

export default function ML08Resultat() {
  const r = useML().result
  return (
    <section data-frame="ML-08" style={{ display: 'grid', gap: 14 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <h2 className="t-section" style={{ flex: 1 }}>{r.title}</h2>
        <Pill tone={r.badge.tone} mark={r.badge.mark}>{r.badge.label}</Pill>
      </div>
      <Note tone="ok">
        Les 7 établissements réussis sont à jour. <strong>Rien n’a été annulé :</strong> une
        application partielle reste appliquée là où elle a fonctionné.
      </Note>
      <div>
        {r.rows.map(row => (
          <ListRow key={row.title} title={row.title} meta={row.meta}
            end={<Button variant="quiet" size="sm">{row.action}</Button>} />
        ))}
      </div>
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
        <Button variant="primary">Réessayer les 2</Button>
        <Button variant="quiet">Télécharger le détail</Button>
      </div>
    </section>
  )
}
